import styled from 'styled-components';

import { Color } from '../../theme';

import { CircleData } from './iconWithTwoCircles.types';

export const Container = styled.div``;

export const InnerIconContainer = styled.div`
  position: relative;
  height: 105px;
  width: 70px;
  margin-left: 50%;
`;

export const Circumference = styled.div`
  height: 70px;
  width: 70px;
  border-radius: 50%;
  border: 0.5px solid ${Color.veryLightGrey};
  position: absolute;
  top: 0;
  z-index: 1;
`;

export const Circle = styled(Circumference)<CircleData>`
  background-color: ${(props: CircleData) => props.backgroundColor};
  border-color: transparent;
  position: absolute;
  bottom: 0;
  top: auto;
  z-index: 0;
`;

export const Icon = styled.img`
  height: 55px;
  position: absolute;
  top: 50%;
  left: -50%;
  transform: translateY(-50%);
  z-index: 2;
`;

export const ChildrenContainer = styled.div`
   height: 55px;
  position: absolute;
  top: 50%;
  left: -50%;
  transform: translateY(-50%);
  z-index: 2;
`;
